import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ResourceGridStyles = makeStyles((theme) => ({
  container: {
    padding: "0 55px 50px 55px",
    margin: "40px 0 40px",
    "& p": {
      fontSize: 18
    }
  },
  header: {
    marginBottom: 40
  },
  linkContainer: {
    "& a": {
      textDecoration: "none",
      color: COLORS.PRIMARY
    }
  },
  cardContainer: {
    boxShadow: "0px 2.7096774578094482px 13.548386573791504px 0px rgba(40, 73, 147, 0.15)",
    "&:hover": {
      transitionDuration: ".5s",
      boxShadow: "0px 2.7096774578094482px 13.548386573791504px 0px rgba(40, 73, 147, 0.25)"
    },
    height: "100%",
    "& a": {
      textDecoration: "none",
      color: COLORS.PRIMARY
    },
    color: COLORS.PRIMARY,
    "& h6": {
      fontWeight: 600
    },
    borderRadius: 10
  },
  innerCardContainer: {
    padding: "30px 20px",
    height: "100%"
  },
  cardHeaderContainer: { alignSelf: "center" },
  arrow: {
    alignItems: "center",
    display: "flex",
    fontSize: "2.5rem",
    color: COLORS.DARK_GRAY
  }
}));

export default ResourceGridStyles;
